import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { MembersTable } from "@/components/team/MembersTable";
import { InvitationsTable } from "@/components/team/InvitationsTable";
import { CreateInvitationDialog } from "@/components/team/CreateInvitationDialog";
import { ErrorBoundary } from "@/components/shared/ErrorBoundary";
import { DashboardLayout } from "@/components/layouts/DashboardLayout";
import { useMembers } from "@/hooks/useMembers";
import { useInvitations } from "@/hooks/useInvitations";
import { useAuth } from "@/hooks/useAuth";
import { canManageTeam } from "@/lib/permissions";

export function Team() {
  const {
    data: members,
    isLoading: membersLoading,
    error: membersError,
  } = useMembers();
  const {
    data: invitations,
    isLoading: invitationsLoading,
    error: invitationsError,
  } = useInvitations();
  const { role } = useAuth();
  const hasManagePermission = canManageTeam(role);

  return (
    <DashboardLayout
      title="Team Management"
      description="Manage your team members and invitations"
      actions={hasManagePermission && <CreateInvitationDialog />}
    >
      <ErrorBoundary>
        <Card>
          <CardHeader>
            <CardTitle>Team Members</CardTitle>
          </CardHeader>
          <CardContent>
            {membersError && (
              <div className="text-destructive mb-4">
                Error loading team members: {membersError.message}
              </div>
            )}
            <MembersTable members={members || []} isLoading={membersLoading} />
          </CardContent>
        </Card>
      </ErrorBoundary>

      <ErrorBoundary>
        <Card>
          <CardHeader>
            <CardTitle>Pending Invitations</CardTitle>
          </CardHeader>
          <CardContent>
            {invitationsError && (
              <div className="text-destructive mb-4">
                Error loading invitations: {invitationsError.message}
              </div>
            )}
            <InvitationsTable
              invitations={invitations || []}
              isLoading={invitationsLoading}
            />
          </CardContent>
        </Card>
      </ErrorBoundary>
    </DashboardLayout>
  );
}
